import { usePointColumns } from "ui/point/hooks/usePointColumns/usePointColumns";
import { BaseTable } from "./PointTable.styles";
import { PointTableProps } from "./PointTable.types";

const PointTable = ({ data = [], isLoading }: PointTableProps) => {
    const columns = usePointColumns();

    return (
        <BaseTable data={data} loading={isLoading} columns={columns} enableSorting={false} />
    );
};

export default PointTable;
